__turbopack_context__.v({
  "buttons-container": "deviceFaultyForm-module-scss-module__0o0LTW__buttons-container",
  "container": "deviceFaultyForm-module-scss-module__0o0LTW__container",
  "error-msg": "deviceFaultyForm-module-scss-module__0o0LTW__error-msg",
  "errorIcon": "deviceFaultyForm-module-scss-module__0o0LTW__errorIcon",
  "form": "deviceFaultyForm-module-scss-module__0o0LTW__form",
  "hint": "deviceFaultyForm-module-scss-module__0o0LTW__hint",
  "status": "deviceFaultyForm-module-scss-module__0o0LTW__status",
});
